module.exports = __webpack_public_path__ + "static/media/gju.bc6d121f.png";